import { IPartnerAppSettings } from '../interface/IPartnerAppSettings';

export const prod: IPartnerAppSettings = {
  cdnBaseUrl: 'https://dmprodadfcdn-addsceafcwenfwer.z01.azurefd.net',
  serviceEndPoints: [
    {
      clientId: '6db56845-5ebb-4b74-88d0-28cc0e41e163',
      serviceEndPoint: 'https://professionalservices.microsoft.com/dm/',
    },
    {
      clientId: '6db0b12a-edd4-4521-8406-a615ce8659d6',
      serviceEndPoint: 'https://oneprofileprodapipack.azurefd.net/api/v1/'
    },
    {
      clientId: '6db0b12a-edd4-4521-8406-a615ce8659d6',
      serviceEndPoint: 'https://oneprofileprodapipack.azurefd.net/api/v2.0/'
    }
  ],
  DmAppConfiguration: {
    'apimSubscriptionKey': '90f2495ce4c44a1594ddbb0715ac6107',
    'cdnBaseUrl': 'https://dmprodadfcdn-addsceafcwenfwer.z01.azurefd.net/',
    'dmServiceBaseUri': 'https://professionalservices.microsoft.com/dm/',
    'esxpBaseUrl': 'https://esxp.microsoft.com/#/',
    'manageAttendeesUrl': 'https://axisng.microsoft.com/Workshop/ViewAttendees/%s',
    'oneProfileBaseUrl': 'https://oneprofileprodapipack.azurefd.net/',
    'irisBaseUrl': 'https://iris-api-fd.azurefd.net/',
    'sourceClientIdForChronos': 900,
    'grmRoleDetailsStateName': 'grm-role-details-experience',
    'oneListUrlWithTPID': 'https://onelistfeedback.microsoft.com/feedback?integrationType=SSD&appURL=%s&appItemId=%s&title=%s&TPID=%s',
    'oneListUrl': 'https://onelistfeedback.microsoft.com/feedback?integrationType=SSD&appURL=https://esxp.microsoft.com/%23/supportdelivery/requestdetails/%s&appItemId=%s&title=%s',
    'workshopServiceCenterUrl': 'https://microsoft.sharepoint.com/teams/Service-Center/SitePages/WorkshopManagement.aspx',
    'createLabUrl': 'https://mslearningcampus.com/User/Login?returnUrl=%2FPages%2Fms-learningcampus',
    'createCertificateUrl': 'https://portal.eventbuilder.com/login?returnUrl=%2Fdashboard',
    'servicesHubUrl': 'https://serviceshub.microsoft.com/home',
    'SNOWUrl': 'https://microsoft.service-now.com/sp/',
    'workshopOneNoteUrl': 'https://nam06.safelinks.protection.outlook.com/?url=https%3A%2F%2Fmicrosoft.sharepoint.com%2Fteams%2FWW_Service_Center_Globalization%2F_layouts%2FOneNote.aspx%3Fid%3D%252Fteams%252FWW_Service_Center_Globalization%252FOneNote%2520Library%252FWW%2520SC%2520Delivery%2520Guidance%26wd%3Dtarget%2528Premier%2520Services%252FWorkshop%2520Management%2520Global%2529&data=04%7C01%7Chiralpatel%40microsoft.com%7Ccfbce9b2b5bd40dcca9a08d8c235b5c1%7C72f988bf86f141af91ab2d7cd011db47%7C0%7C0%7C637472883225302783%7CUnknown%7CTWFpbGZsb3d8eyJWIjoiMC4wLjAwMDAiLCJQIjoiV2luMzIiLCJBTiI6Ik1haWwiLCJXVCI6Mn0%3D%7C1000&sdata=hNmY3eWPsSYFEj6c%2F97uEtcmDz3yJnffEbMgZwfL94Y%3D&reserved=0',
    'enableSandboxPage': false,
    'svcSpecialistAccessRequestTeamsDetails': {
      'teamName': 'SD Access Requests',
      'teamChannelName': 'Access Request - Production'
    },
    'rmexBaseUrl': 'https://professionalservices.microsoft.com/rmsvc/api/',
    'rmexSubscriptionKey': '1dde0863045642c59820b2462fe1b2e4',
    'appInsights-instrumentationKey': '5cd91210-6cc4-4f2d-8b46-90e429c8ed4d',
    'dynamicsBaseUrl': 'https://microsoftsales.crm.dynamics.com/',
    'csaRoleIds': '28,159,163,187,59'
  }
};
